import { Platform } from "@angular/cdk/platform";

export class PlatformHelper {
    public static Platform;
    public static Initialize(platform: Platform) {
        PlatformHelper.Platform = platform;
    }
}
